import { useEffect, useRef } from 'react';

const ADSENSE_CLIENT =
  process.env.REACT_APP_ADSENSE_CLIENT || 'ca-pub-9401681619322551';

export default function AdSlot({
  slot,
  format = 'auto',
  responsive = true,
  style = { display: 'block' },
  className = '',
}) {
  const insRef = useRef(null);
  const pushed = useRef(false);

  useEffect(() => {
    if (!ADSENSE_CLIENT || !slot || pushed.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushed.current = true;
    } catch (e) {
      // AdSense script not loaded yet or blocked — silently ignore.
    }
  }, [slot]);

  if (!ADSENSE_CLIENT || !slot) {
    return (
      <div className={`ad-placeholder ${className}`} aria-label="Advertisement placeholder">
        <span>Ad space</span>
        <small>Set REACT_APP_ADSENSE_CLIENT and pass a slot ID to enable ads.</small>
      </div>
    );
  }

  return (
    <ins
      ref={insRef}
      className={`adsbygoogle ${className}`}
      style={style}
      data-ad-client={ADSENSE_CLIENT}
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive={responsive ? 'true' : 'false'}
    />
  );
}
